import "./Cards.scss";
import Card from "components/Card/Card";

interface CardsProps {
  cardsArr: {
    title: string;
    description: string;
  }[];
}

const Cards = ({ cardsArr }: CardsProps) => {
  return (
    <div className="cards-blocks">
      {cardsArr.map((block, index) => {
        return (
          <Card key={index} title={block.title} text={block.description} />
        );
      })}
    </div>
  );
};
export default Cards;
